import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import InputMask from 'react-input-mask';
import useFormValidator from 'useFormValidator';
import moment from 'moment';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import DragAndDrop from 'modules/common/components/DragAndDrop';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { ModalContext } from 'App';
import { customStyle } from 'helper';
import * as actions from '../action';
import * as c from '../constant';
import OwnerComponent from '../components/OwnerComponent';

const RULES = {
  tab0: {
    rules: {
      property_district_id: 'required',
      property_barangay_id: 'required',
      property_street: 'required',
      property_boundaries_north: 'required',
      property_boundaries_south: 'required',
      property_boundaries_east: 'required',
      property_boundaries_west: 'required',
      property_boundaries_land_sketch_photo_url: 'required',
    },
  },
  tab1: {
    rules: {
      rptax_transaction_code_id: 'required',
      tdn: 'required',
      arp_no: 'required',
      pin: 'required',
      lot_no: 'required',
      blk: 'required',
      rptax_owner_id: 'required',
      administrator_beneficial_user: 'required',
      administrator_beneficial_address: 'required',
      administrator_beneficial_telephone_no: 'required|tel_number',
      administrator_beneficial_tin: 'required',
      oct_tct_cloa_no: 'required',
      oct_tct_cloa_dated: 'required',
      registered: 'required',
      survey_no: 'required',
    },
  },
  tab2: {
    rules: {
      effectivity_of_assessment_reassessment_yr: 'required',
      effectivity_of_assessment_reassessment_qtr: 'required',
      appraised_assessed_at: 'required',
      recommending_by_id: 'required',
      recommending_at: 'required',
      approved_by_id: 'required',
      approved_at: 'required',
      memoranda: 'required',
      appraised_assessed_by_id: 'required',
    },
  },
};

const quarterList = [
  { label: '1ST QUARTER', value: '1' },
  { label: '2ND QUARTER', value: '2' },
  { label: '3RD QUARTER', value: '3' },
  { label: '4TH QUARTER', value: '4' },
];

const years = _.range(
  +moment().format('YYYY'),
  +moment().format('YYYY') + 2
).sort((a, b) => b - a);

function LandApplicationModal({
  createRichTextEditor,
  formData,
  setFormData,
  createUploader,
  createLandApplication,
  updateLandApplication,
  applicationInfo,
  applicationType,
  history,
  id,
  getSingleLandApplication,
  getTransactionCodesList,
  getLandOwnerList,
  transactionList,
  ownerList,
  updateList,
  getProvinceList,
  getDistrictList,
  getBarangayList,
  provinceList,
  districtList,
  barangayList,
  type,
  getLandApplicationsList,
  htmlToDraft,
  draftToHtml,
  convertToRaw,
  getTdn,
  getPin,
  getLocationList,
  locationList,
  getPersonOfConcernList,
  personOfConcernList,
  getEffectivityDateTransfer,
  effectivityDate,
}) {
  const [tab, setTab] = useState(0);
  const [pinEnable, setPinEnable] = useState(false);

  const tab0Validator = useFormValidator(
    formData,
    RULES.tab0.rules,
    RULES.tab0.message
  );
  const tab1Validator = useFormValidator(
    formData,
    RULES.tab1.rules,
    RULES.tab1.message
  );
  const tab2Validator = useFormValidator(
    formData,
    RULES.tab2.rules,
    RULES.tab2.message
  );

  const tab0Field = _.pick(formData, [
    'property_district_id',
    'property_barangay_id',
    'property_street',
    'property_boundaries_north',
    'property_boundaries_south',
    'property_boundaries_east',
    'property_boundaries_west',
    'property_boundaries_land_sketch_photo_url',
  ]);

  const tab1Field = _.pick(formData, [
    'rptax_transaction_code_id',
    'tdn',
    'arp_no',
    'pin',
    'lot_no',
    'blk',
    'rptax_owner_id',
    'administrator_beneficial_user',
    'administrator_beneficial_address',
    'administrator_beneficial_telephone_no',
    'administrator_beneficial_tin',
  ]);

  const tab2Field = _.pick(formData, [
    'effectivity_of_assessment_reassessment_yr',
    'effectivity_of_assessment_reassessment_qtr',
    'appraised_assessed_by_id',
    'appraised_assessed_at',
    'recommending_by_id',
    'recommending_at',
    'approved_by_id',
    'approved_at',
    'memoranda',
  ]);

  useEffect(() => {
    tab0Validator.validate();
  }, [Object.values(tab0Field).join(',')]);

  useEffect(() => {
    tab1Validator.validate();
  }, [Object.values(tab1Field).join(',')]);

  useEffect(() => {
    tab2Validator.validate();
  }, [Object.values(tab2Field).join(',')]);

  const validateForm = () => {
    if (tab === 0) {
      if (!tab0Validator.response.is_passed) {
        return false;
      }

      return setTab(+tab + 1);
    }

    if (tab === 1) {
      if (!tab1Validator.response.is_passed) {
        return false;
      }

      return setTab(+tab + 1);
    }

    if (tab === 2) {
      if (!tab2Validator.response.is_passed) {
        return false;
      }
    }

    return true;
  };

  const paginateButton = () => {
    return (
      <>
        {tab !== 2 && (
          <div className="col-12 d-flex justify-content-center pt-5">
            {/* onClick={onSetTab(+tab+1)} */}
            {tab !== 0 && (
              <button
                type="button"
                onClick={() => setTab(+tab - 1 < 0 ? 0 : +tab - 1)}
                className="btn cms-bg-color-light mr-1"
              >
                Previous
              </button>
            )}
            <button
              type="submit"
              className="btn button-proceed ml-1 cms-bg-color-primary text-white"
              disabled={
                (tab === 0 && !tab0Validator.response.is_passed) ||
                (tab === 1 && !tab1Validator.response.is_passed)
              }
            >
              Proceed
            </button>
          </div>
        )}
        {tab === 2 && (
          <div className="col-12 d-flex justify-content-center mt-3">
            <button
              type="button"
              onClick={() => setTab(+tab - 1 < 0 ? 0 : +tab - 1)}
              className="btn cms-bg-color-light mr-1"
            >
              Previous
            </button>
            <button
              disabled={tab === 2 && !tab2Validator.response.is_passed}
              type="submit"
              className="btn button-proceed ml-1 cms-bg-color-primary text-white"
            >
              Proceed
            </button>
          </div>
        )}
      </>
    );
  };

  const yearOptions =
    ['TR', 'SD', 'DP', 'PC', 'D', 'R', 'CS'].indexOf(applicationType.code) > -1
      ? effectivityDate.map((item) => ({
          label: item.year,
          value: item.year,
        }))
      : years.map((year) => ({
          label: year,
          value: year,
        }));

  const qtrOptions =
    ['TR', 'SD', 'DP', 'PC', 'D', 'R'].indexOf(applicationType.code) > -1 &&
    !_.isEmpty(formData, 'effectivity_of_assessment_reassessment_yr')
      ? effectivityDate
          .find(
            (item) =>
              +item.year ===
              +_.get(formData, 'effectivity_of_assessment_reassessment_yr')
          )
          ?.quarter?.map((item) => ({
            label: quarterList.find((qtr) => +qtr.value === +item)?.label,
            value: item,
          }))
      : quarterList;

  const setModal = useContext(ModalContext);

  useEffect(() => {
    getTransactionCodesList();
  }, []);

  useEffect(() => {
    getLandOwnerList();
  }, []);

  useEffect(() => {
    getProvinceList();
  }, []);

  useEffect(() => {
    getDistrictList({
      province_id: 65,
    });
  }, []);

  const handleOnChangeDate = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e.target.value,
    });
  };

  const onChangePhoto = (key) => (data) => {
    setFormData({
      ...formData,
      [key]: data.cdnUrl,
    });
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (validateForm() !== true) {
      return false;
    }

    const finalCoOwners = [];

    (_.get(formData, 'rptax_co_owners') || []).forEach((element) => {
      finalCoOwners.push(element.rptax_co_owners);
    });

    const args = {
      ...formData,
      property_boundaries_land_sketch_photo_url:
        formData.property_boundaries_land_sketch_photo_url.cdnUrl === undefined
          ? formData.property_boundaries_land_sketch_photo_url
          : formData.property_boundaries_land_sketch_photo_url.cdnUrl,
      registered: `${moment(
        _.get(formData, 'registered')
      ).format('YYYY-MM-DD HH:mm')}:00`,
      appraised_assessed_at: `${moment(
        _.get(formData, 'appraised_assessed_at')
      ).format('YYYY-MM-DD HH:mm')}:00`,
      recommending_at: `${moment(_.get(formData, 'recommending_at')).format(
        'YYYY-MM-DD HH:mm'
      )}:00`,
      approved_at: `${moment(_.get(formData, 'approved_at')).format(
        'YYYY-MM-DD HH:mm'
      )}:00`,
      overwrite_pin: _.get(formData, 'overwrite_pin')
        ? _.get(formData, 'overwrite_pin')
        : false,
      memoranda: draftToHtml(
        convertToRaw(formData.memoranda.getCurrentContent())
      ),
      rptax_co_owners: finalCoOwners,
    };

    if (type === 'NEW') {
      createLandApplication(args, ({ data }) => {
        setModal({ isOpen: false });
        getLandApplicationsList();
        history.push(`/rpt/land/applications/${_.get(data, 'id')}`);
        getSingleLandApplication(_.get(data, 'id'));
      });
    }

    if (type === 'EDIT') {
      updateLandApplication(id, args, ({ data }) => {
        setModal({ isOpen: false });
        getLandApplicationsList();
        history.push(`/rpt/land/applications/${_.get(data, 'id')}`);
        getSingleLandApplication(_.get(data, 'id'));
      });
    }

    return false;
  };

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      getBarangayList({
        rptax_district_id: _.get(updateList, 'property_district_id'),
      });
      getLocationList({
        rptax_district_id: _.get(updateList, 'property_district_id'),
      });

      const finalCoOwners = [];

      (
        _.get(applicationInfo, 'included.landApplicationCoOwners') || []
      ).forEach((element) => {
        finalCoOwners.push({
          id: _.get(element, 'attributes.details.id'),
          rptax_co_owners: _.get(element, 'attributes.details.id'),
        });
      });

      const editTransfer = {
        rptax_co_owners: [],
        effectivity_of_assessment_reassessment_yr: '',
        effectivity_of_assessment_reassessment_qtr: '',
      };
      const editSubdivision = {
        rptax_co_owners: [],
        // effectivity_of_assessment_reassessment_yr: +_.get(
        //   updateList,
        //   'effectivity_of_assessment_reassessment_yr'
        // ),
        // effectivity_of_assessment_reassessment_qtr: +_.get(
        //   updateList,
        //   'effectivity_of_assessment_reassessment_qtr'
        // ),
      };

      const args = {
        ...updateList,
        memoranda: htmlToDraft(updateList.memoranda),
        oldPin: updateList.pin || '',
        rptax_co_owners: finalCoOwners,
        appraised_assessed_by_id: updateList.appraised_assessed_by_id || '',
        recommending_by_id: updateList.recommending_by_id || '',
        approved_by_id: updateList.approved_by_id || '',
        appraised_assessed_at:
          updateList.appraised_assessed_at ||
          `${moment(new Date()).format('YYYY-MM-DD HH:mm')}:00`,
        recommending_at:
          updateList.recommending_at ||
          `${moment(new Date()).format('YYYY-MM-DD HH:mm')}:00`,
        approved_at:
          ['DP', 'PC', 'D', 'R'].indexOf(applicationType.code) > -1 &&
          _.isEmpty(updateList.approved_at)
            ? ''
            : updateList.approved_at ||
              `${moment(new Date()).format('YYYY-MM-DD HH:mm')}:00`,
        ...(type === 'EDIT' &&
          ['TR'].indexOf(applicationType.code) > -1 &&
          editTransfer),
        ...(type === 'EDIT' &&
          ['SD', 'DP', 'PC', 'D', 'R'].indexOf(applicationType.code) > -1 &&
          editSubdivision),
      };

      setFormData(_.pick(args, _.keys(c.FORM_DATA)));
    }
  };

  useEffect(() => {
    if (type === 'NEW') {
      const args = {
        ...c.FORM_DATA,
        date_issued: `${moment(_.get(formData, 'date_issued')).format(
          'YYYY-MM-DD HH:mm'
        )}:00`,
        certificate_completion_issued_on: `${moment(
          _.get(formData, 'certificate_completion_issued_on')
        ).format('YYYY-MM-DD HH:mm')}:00`,
        certificate_occupancy_issued_on: `${moment(
          _.get(formData, 'certificate_occupancy_issued_on')
        ).format('YYYY-MM-DD HH:mm')}:00`,
        date_occupied: `${moment(_.get(formData, 'date_occupied')).format(
          'YYYY-MM-DD HH:mm'
        )}:00`,
        appraised_assessed_at: `${moment(
          _.get(formData, 'appraised_assessed_at')
        ).format('YYYY-MM-DD HH:mm')}:00`,
        recommending_at: `${moment(_.get(formData, 'recommending_at')).format(
          'YYYY-MM-DD HH:mm'
        )}:00`,
        approved_at: `${moment(_.get(formData, 'approved_at')).format(
          'YYYY-MM-DD HH:mm'
        )}:00`,
        date_constructed_completed: `${moment(
          _.get(formData, 'date_constructed_completed')
        ).format('YYYY-MM-DD HH:mm')}:00`,
      };
      setFormData(args);
    }
    if (type === 'EDIT') {
      onSetFormData();
    }
  }, []);

  const createDropdownProvince = (list) => {
    const newList = [];
    list.map((data) => {
      return newList.push({
        label: data.attributes.name,
        value: data.id,
      });
    });
    return newList;
  };

  const handleBarangaySelect = (e) => {
    getTdn({ barangay_id: e.value }, (tdnData) => {
      getPin({ barangay_id: e.value }, (pinData) => {
        setFormData({
          ...formData,
          property_barangay_id: e.value,
          tdn: tdnData.data,
          arp_no: tdnData.data,
          pin: pinData.data,
        });
      });
    });
  };

  const handleTransactCodeSelect = (e) => {
    setFormData({
      ...formData,
      rptax_transaction_code_id: e.value,
    });
  };

  const onChange = (e) => {
    return setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  const ownerOptions = ownerList.map((x) => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const handleSelected = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e.value,
    });
    if (key === 'property_district_id') {
      getBarangayList({
        rptax_district_id: e.value,
      });
      getLocationList({
        rptax_district_id: e.value,
      });
    }
  };

  const locationOptions = locationList.map((x) => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const transactionOptions = transactionList.map((x) => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const createDropdownBarangay = (list) => {
    const newList = [];
    list.map((data) => {
      return newList.push({
        label: data.attributes.name,
        value: data.id,
      });
    });
    return newList;
  };

  const districtOptions = districtList.map((x) => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const handleEnablePin = (e) => {
    if (e.target.checked) {
      setPinEnable(true);
      setFormData({
        ...formData,
        pin: formData.oldPin,
        overwrite_pin: true,
      });
    } else {
      setPinEnable(false);
      getPin(
        { barangay_id: _.get(formData, 'property_barangay_id') },
        (pinData) => {
          setFormData({
            ...formData,
            pin: pinData.data,
            overwrite_pin: false,
          });
        }
      );
    }
  };

  const handleChange = (key) => (data) => {
    setFormData({
      ...formData,
      [key]: data,
    });
  };

  useEffect(() => {
    getPersonOfConcernList();
    if (
      ['TR', 'SD', 'DP', 'PC', 'D', 'R', 'CS'].indexOf(applicationType.code) >
      -1
    ) {
      getEffectivityDateTransfer(id);
    }
  }, []);

  // useEffect(() => {
  //   if (
  //     !_.isEmpty(formData) &&
  //     !_.isEmpty(effectivityDate) &&
  //     type === 'EDIT' &&
  //     ['TR', 'SD'].indexOf(applicationType.code) > -1
  //   ) {
  //     setFormData({
  //       ...formData,
  //       effectivity_of_assessment_reassessment_yr: _.get(
  //         effectivityDate,
  //         'year'
  //       ),
  //       effectivity_of_assessment_reassessment_qtr: `${_.get(
  //         effectivityDate,
  //         'quarter'
  //       )}`,
  //     });
  //   }
  // }, [effectivityDate]);

  const pocOptions = personOfConcernList.map((item) => {
    return {
      value: item.id,
      label: item.attributes.full_name,
      is_approver: item.attributes.is_approver,
      is_assessor: item.attributes.is_assessor,
      is_recommender: item.attributes.is_recommender,
    };
  });
  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        {tab === 0 && (
          <>
            <div className="row">
              <div className="col-12 py-0 mb-2">
                <h3 className="m-0 text-color font-weight-bold">
                  Property Location
                </h3>
              </div>
              <div className="col-6 form-group">
                <div className="">
                  <label className="form-label">Select Province</label>
                  <div>
                    <Select
                      value={
                        createDropdownProvince(provinceList).filter(
                          (item) =>
                            +_.get(formData, 'property_province_id') ===
                            +_.get(item, 'value')
                        ) || ''
                      }
                      isDisabled
                      styles={customStyle}
                      placeholder="Select Province"
                      options={createDropdownProvince(provinceList)}
                    />
                  </div>
                </div>
              </div>
              <div className="col-6">
                <label className="form-label">
                  Select District &nbsp;{' '}
                  {tab0Validator.renderMessage('property_district_id')}
                </label>
                <div>
                  <div>
                    <Select
                      options={districtOptions}
                      styles={customStyle}
                      placeholder="Select District"
                      value={
                        districtOptions.filter(
                          (item) =>
                            +_.get(formData, 'property_district_id') ===
                            +_.get(item, 'id')
                        ) || ''
                      }
                      onChange={handleSelected('property_district_id')}
                    />
                  </div>
                </div>
              </div>
              <div className="col-6 pt-1">
                <label className="form-label">
                  Select Barangay &nbsp;{' '}
                  {tab0Validator.renderMessage('property_barangay_id')}
                </label>
                <div>
                  <Select
                    options={createDropdownBarangay(barangayList)}
                    styles={customStyle}
                    placeholder="Select Barangay"
                    value={
                      createDropdownBarangay(barangayList).filter(
                        (item) =>
                          +_.get(formData, 'property_barangay_id') ===
                          +_.get(item, 'value')
                      ) || ''
                    }
                    onChange={(e) => {
                      handleBarangaySelect(e);
                    }}
                  />
                </div>
              </div>
              <div className="col-6 form-group">
                <label className="form-label">Location</label>
                <div>
                  <Select
                    options={locationOptions}
                    styles={customStyle}
                    placeholder="Select Location"
                    value={
                      locationOptions.filter(
                        (item) =>
                          +_.get(formData, 'property_location_id') ===
                          +_.get(item, 'id')
                      ) || ''
                    }
                    onChange={handleSelected('property_location_id')}
                  />
                </div>
              </div>
              <div className="col-6 form-group pt-1">
                <label htmlFor="last_name" className="form-label mb-0">
                  Street &nbsp; {tab0Validator.renderMessage('property_street')}
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="property_street"
                  onChange={onChange}
                  value={_.get(formData, 'property_street') || ''}
                />
              </div>
              <div className="col-12 font-weight-bold">Boundaries:</div>
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label mb-0">
                  North &nbsp;{' '}
                  {tab0Validator.renderMessage('property_boundaries_north')}
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="property_boundaries_north"
                  onChange={onChange}
                  value={_.get(formData, 'property_boundaries_north') || ''}
                />
              </div>
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label mb-0">
                  South &nbsp;{' '}
                  {tab0Validator.renderMessage('property_boundaries_south')}
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="property_boundaries_south"
                  onChange={onChange}
                  value={_.get(formData, 'property_boundaries_south') || ''}
                />
              </div>
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label mb-0">
                  East &nbsp;{' '}
                  {tab0Validator.renderMessage('property_boundaries_east')}
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="property_boundaries_east"
                  onChange={onChange}
                  value={_.get(formData, 'property_boundaries_east') || ''}
                />
              </div>
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label mb-0">
                  West &nbsp;{' '}
                  {tab0Validator.renderMessage('property_boundaries_west')}
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="property_boundaries_west"
                  onChange={onChange}
                  value={_.get(formData, 'property_boundaries_west') || ''}
                />
              </div>
              <div className="col-12 form-group">
                <label className="font-weight-bold">Upload Land Sketch:</label>{' '}
                &nbsp;{' '}
                {tab0Validator.renderMessage(
                  'property_boundaries_land_sketch_photo_url'
                )}
                <div className="row d-flex">
                  <div className="col-3">
                    <div
                      className="generic-listing bg-primary p-3 arrow rounded"
                      style={{
                        // overflowY: 'scroll',
                        display: 'block',
                      }}
                    >
                      <label className="form-label text-white">
                        Land Sketch
                      </label>
                    </div>
                  </div>
                  <div className="col-12 col-md-8">
                    <div className="form-wrapper arrow-card p-4">
                      {!_.get(
                        formData,
                        'property_boundaries_land_sketch_photo_url'
                      ) ? (
                        <DragAndDrop
                          onChange={onChangePhoto(
                            'property_boundaries_land_sketch_photo_url'
                          )}
                          maxSize={2}
                          caption="JPEG. PNG. Maximum size 2MB."
                          label="Upload your Requirements here"
                          fileType="image/jpeg, image/jpg, image/png"
                        />
                      ) : (
                        <div className="bg-dark text-center py-2 pb-5 rounded">
                          <div className="d-flex justify-content-end col-1">
                            {createUploader(
                              {
                                key: 'property_boundaries_land_sketch_photo_url',
                                label: 'Sketch',
                              },
                              { placeholder: '  ' }
                            )}
                          </div>
                          <img
                            src={
                              !_.isObject(
                                _.get(
                                  formData,
                                  'property_boundaries_land_sketch_photo_url'
                                ) || ''
                              )
                                ? _.get(
                                    formData,
                                    'property_boundaries_land_sketch_photo_url'
                                  ) || ImagePlaceholder
                                : _.get(
                                    formData,
                                    'property_boundaries_land_sketch_photo_url.cdnUrl'
                                  ) || ImagePlaceholder
                            }
                            className="img-fluid shadow-lg"
                            role="presentation"
                            width="70%"
                            alt=""
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-center mt-4">
              {paginateButton()}
            </div>
          </>
        )}
        {tab === 1 && (
          <>
            <div className="row">
              <div className="col-12 py-0 mb-2">
                <h3 className="m-0 text-color font-weight-bold">Information</h3>
              </div>
              <div className="col-6 form-group">
                <label className="form-label">
                  Transaction Code &nbsp;{' '}
                  {tab1Validator.renderMessage('rptax_transaction_code_id')}
                </label>
                <div>
                  <Select
                    options={transactionOptions}
                    styles={customStyle}
                    placeholder="Select Transact Code"
                    value={
                      transactionOptions.filter(
                        (item) =>
                          +_.get(formData, 'rptax_transaction_code_id') ===
                          +_.get(item, 'id')
                      ) || ''
                    }
                    onChange={(e) => {
                      handleTransactCodeSelect(e);
                    }}
                    isDisabled={type === 'EDIT'}
                  />
                </div>
              </div>
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label">
                  TDN &nbsp; {tab1Validator.renderMessage('tdn')}
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="tdn"
                  value={_.get(formData, 'tdn') || ''}
                  disabled
                />
              </div>
              <div className="col-6 form-group">
                <label className="form-label">
                  ARP No. &nbsp; {tab1Validator.renderMessage('arp_no')}
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="arp_no"
                  value={_.get(formData, 'arp_no') || ''}
                  disabled
                />
              </div>
              <div className="col-6 form-group">
                <div className="d-flex">
                  <label className="form-label">
                    PIN &nbsp; {tab1Validator.renderMessage('pin')}
                  </label>
                  <label className="form-label ml-auto">
                    Overwrite PIN: &nbsp;
                    <input
                      name="pinEnable"
                      type="checkbox"
                      checked={pinEnable}
                      onChange={handleEnablePin}
                      className="m-0"
                    />
                  </label>
                </div>
                <InputMask
                  className="form-control"
                  mask="999-99-999-999-999"
                  alwaysShowMask
                  type="text"
                  name="pin"
                  onChange={onChange}
                  value={_.get(formData, 'pin')}
                />
              </div>
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label mb-0">
                  OCT/TCT/CLOA No. &nbsp;{' '}
                  {tab1Validator.renderMessage('oct_tct_cloa_no')}
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="oct_tct_cloa_no"
                  onChange={onChange}
                  value={_.get(formData, 'oct_tct_cloa_no') || ''}
                />
              </div>
              <div className="form-input-group col-3">
                <label htmlFor="last_name" className="form-label mb-0">
                  OCT/TCT/CLOA Date &nbsp;{' '}
                  {tab1Validator.renderMessage('oct_tct_cloa_dated')}
                </label>
                <DateInputPicker
                  withTime
                  className="full-input"
                  onChange={handleOnChangeDate('oct_tct_cloa_dated')}
                  value={_.get(formData, 'oct_tct_cloa_dated') || ''}
                  maxDate={new Date()}
                />
              </div>
              <div className="form-input-group col-3">
                <label htmlFor="last_name" className="form-label mb-0">
                  Date of Registration &nbsp;{' '}
                  {tab1Validator.renderMessage('registered')}
                </label>
                <DateInputPicker
                  withTime
                  className="full-input"
                  onChange={handleOnChangeDate('registered')}
                  value={
                    _.get(formData, 'registered')
                      ? `${moment(_.get(formData, 'registered')).format(
                          'MM-DD-YYYY HH:mm'
                        )}:00`
                      : ''
                  }
                  maxDate={new Date()}
                />
              </div>
              <div className="col-2 form-group">
                <label htmlFor="last_name" className="form-label mb-0">
                  Survey No. &nbsp; {tab1Validator.renderMessage('survey_no')}
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="survey_no"
                  onChange={onChange}
                  value={_.get(formData, 'survey_no') || ''}
                />
              </div>
              <div className="col-2 form-group">
                <label htmlFor="last_name" className="form-label mb-0">
                  Lot No. &nbsp; {tab1Validator.renderMessage('lot_no')}
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="lot_no"
                  onChange={onChange}
                  value={_.get(formData, 'lot_no') || ''}
                />
              </div>
              <div className="col-2 form-group">
                <label htmlFor="last_name" className="form-label mb-0">
                  Block &nbsp; {tab1Validator.renderMessage('blk')}
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="blk"
                  onChange={onChange}
                  value={_.get(formData, 'blk') || ''}
                />
              </div>
              <div className="col-6 form-group">
                <label className="form-label">
                  Owner &nbsp; {tab1Validator.renderMessage('rptax_owner_id')}
                </label>
                <div>
                  <Select
                    options={ownerOptions}
                    styles={customStyle}
                    placeholder="Select Owner"
                    value={
                      ownerOptions.filter(
                        (item) =>
                          +_.get(formData, 'rptax_owner_id') ===
                          +_.get(item, 'id')
                      ) || ''
                    }
                    onChange={handleSelected('rptax_owner_id')}
                  />
                </div>
              </div>
              <div className="col-12 form-group">
                <OwnerComponent
                  value={formData.rptax_co_owners || []}
                  onChange={handleChange('rptax_co_owners')}
                  formData={formData}
                  type={formData.type}
                  setFormData={setFormData}
                />
              </div>
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label mb-0">
                  Administrator/Beneficial User &nbsp;{' '}
                  {tab1Validator.renderMessage('administrator_beneficial_user')}
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="administrator_beneficial_user"
                  onChange={onChange}
                  value={_.get(formData, 'administrator_beneficial_user') || ''}
                />
              </div>
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label mb-0">
                  Address &nbsp;{' '}
                  {tab1Validator.renderMessage(
                    'administrator_beneficial_address'
                  )}
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="administrator_beneficial_address"
                  onChange={onChange}
                  value={
                    _.get(formData, 'administrator_beneficial_address') || ''
                  }
                />
              </div>
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label mb-0">
                  Tel. No. &nbsp;{' '}
                  {tab1Validator.renderMessage(
                    'administrator_beneficial_telephone_no'
                  )}
                </label>
                <InputMask
                  className="form-control"
                  mask="99-9999-9999"
                  alwaysShowMask
                  type="text"
                  name="administrator_beneficial_telephone_no"
                  onChange={onChange}
                  value={_.get(
                    formData,
                    'administrator_beneficial_telephone_no'
                  )}
                />
              </div>
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label mb-0">
                  Tax Identification Number &nbsp;{' '}
                  {tab1Validator.renderMessage('administrator_beneficial_tin')}
                </label>
                <InputMask
                  className="form-control"
                  mask="999-999-999-999"
                  type="text"
                  name="administrator_beneficial_tin"
                  onChange={onChange}
                  value={_.get(formData, 'administrator_beneficial_tin') || ''}
                />
              </div>
            </div>
            <div className="text-center mt-4">{paginateButton()}</div>
          </>
        )}
        {tab === 2 && (
          <>
            <div className="row">
              <div className="col-12 py-0 mb-2">
                <h3 className="m-0 text-color font-weight-bold">
                  General Description
                </h3>
              </div>
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label">
                  Effectivity of Assessment Year &nbsp;{' '}
                  {tab2Validator.renderMessage(
                    'effectivity_of_assessment_reassessment_yr'
                  )}
                </label>
                <Select
                  options={yearOptions}
                  styles={customStyle}
                  placeholder="Select Year"
                  value={yearOptions.find(
                    (item) =>
                      item.value ===
                      _.get(
                        formData,
                        'effectivity_of_assessment_reassessment_yr'
                      )
                  )}
                  onChange={handleSelected(
                    'effectivity_of_assessment_reassessment_yr'
                  )}
                  isDisabled={
                    type === 'EDIT' && ['SD'].indexOf(applicationType.code) > -1
                  }
                />
              </div>
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label">
                  Effectivity of Assessment Quarter &nbsp;{' '}
                  {tab2Validator.renderMessage(
                    'effectivity_of_assessment_reassessment_qtr'
                  )}
                </label>
                <Select
                  options={qtrOptions}
                  styles={customStyle}
                  placeholder="Select Quarter"
                  value={qtrOptions?.find(
                    (item) =>
                      +item.value ===
                      +_.get(
                        formData,
                        'effectivity_of_assessment_reassessment_qtr'
                      )
                  )}
                  isOptionDisabled={(option) =>
                    +option.value < +_.get(effectivityDate, 'quarter')
                  }
                  onChange={handleSelected(
                    'effectivity_of_assessment_reassessment_qtr'
                  )}
                  isDisabled={
                    type === 'EDIT' && ['SD'].indexOf(applicationType.code) > -1
                  }
                />
              </div>
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label">
                  Appraised/Assessed By &nbsp;{' '}
                  {tab2Validator.renderMessage('appraised_assessed_by_id')}
                </label>
                <Select
                  options={pocOptions.filter((item) => item.is_assessor === 1)}
                  styles={customStyle}
                  placeholder="Select Assessor"
                  value={pocOptions.filter((item) => {
                    return (
                      +item.value ===
                      +_.get(formData, 'appraised_assessed_by_id')
                    );
                  })}
                  onChange={handleSelected('appraised_assessed_by_id')}
                />
              </div>
              <div className="form-input-group col-6">
                <label htmlFor="last_name" className="form-label">
                  Appraised/Assessed At: &nbsp;{' '}
                  {tab2Validator.renderMessage('appraised_assessed_at')}
                </label>
                <DateInputPicker
                  withTime
                  className="full-input"
                  onChange={handleOnChangeDate('appraised_assessed_at')}
                  value={
                    _.get(formData, 'appraised_assessed_at')
                      ? `${moment(
                          _.get(formData, 'appraised_assessed_at')
                        ).format('MM-DD-YYYY HH:mm')}:00`
                      : ''
                  }
                  maxDate={new Date()}
                />
              </div>
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label">
                  Recommended By &nbsp;{' '}
                  {tab2Validator.renderMessage('recommending_by_id')}
                </label>
                <Select
                  options={pocOptions.filter(
                    (item) => item.is_recommender === 1
                  )}
                  styles={customStyle}
                  placeholder="Select Recommender"
                  value={pocOptions.filter((item) => {
                    return (
                      +item.value === +_.get(formData, 'recommending_by_id')
                    );
                  })}
                  onChange={handleSelected('recommending_by_id')}
                />
              </div>
              <div className="form-input-group col-6">
                <label htmlFor="last_name" className="form-label">
                  Recommended At: &nbsp;{' '}
                  {tab2Validator.renderMessage('recommending_at')}
                </label>
                <DateInputPicker
                  withTime
                  className="full-input"
                  onChange={handleOnChangeDate('recommending_at')}
                  value={
                    _.get(formData, 'recommending_at')
                      ? `${moment(_.get(formData, 'recommending_at')).format(
                          'MM-DD-YYYY HH:mm'
                        )}:00`
                      : ''
                  }
                  maxDate={new Date()}
                />
              </div>
              <div className="col-6 form-group">
                <label htmlFor="last_name" className="form-label">
                  Approved By &nbsp;{' '}
                  {tab2Validator.renderMessage('approved_by_id')}
                </label>
                <Select
                  options={pocOptions.filter((item) => item.is_approver === 1)}
                  styles={customStyle}
                  placeholder="Select Approver"
                  value={pocOptions.filter((item) => {
                    return +item.value === +_.get(formData, 'approved_by_id');
                  })}
                  onChange={handleSelected('approved_by_id')}
                />
              </div>
              <div className="form-input-group col-6">
                <label htmlFor="last_name" className="form-label">
                  Approved At: &nbsp;{' '}
                  {tab2Validator.renderMessage('approved_at')}
                </label>
                <DateInputPicker
                  withTime
                  className="full-input"
                  onChange={handleOnChangeDate('approved_at')}
                  value={
                    _.get(formData, 'approved_at')
                      ? `${moment(_.get(formData, 'approved_at')).format(
                          'MM-DD-YYYY HH:mm'
                        )}:00`
                      : ''
                  }
                  maxDate={new Date()}
                />
              </div>
              <div className="col-12 form-group" style={{ zIndex: 0 }}>
                {createRichTextEditor(
                  { key: 'memoranda', label: 'Memoranda:' },
                  { minLength: 3, required: true }
                )}
              </div>
            </div>
            <br />
            <div className="text-center mt-5">{paginateButton()}</div>
          </>
        )}
      </form>
    </Modal.Body>
  );
}

LandApplicationModal.defaultProps = {
  type: '',
  id: '',
  updateList: {},
  applicationInfo: {},
  applicationType: {},
};

LandApplicationModal.propTypes = {
  createRichTextEditor: PropTypes.instanceOf(Function).isRequired,
  createUploader: PropTypes.instanceOf(Function).isRequired,
  createLandApplication: PropTypes.instanceOf(Function).isRequired,
  updateLandApplication: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string,
  history: PropTypes.instanceOf(Object).isRequired,
  getSingleLandApplication: PropTypes.instanceOf(Function).isRequired,
  getTransactionCodesList: PropTypes.instanceOf(Function).isRequired,
  getLandOwnerList: PropTypes.instanceOf(Function).isRequired,
  transactionList: PropTypes.instanceOf(Array).isRequired,
  ownerList: PropTypes.instanceOf(Array).isRequired,
  updateList: PropTypes.instanceOf(Object),
  applicationInfo: PropTypes.instanceOf(Object),
  applicationType: PropTypes.instanceOf(Object),
  getProvinceList: PropTypes.instanceOf(Function).isRequired,
  getDistrictList: PropTypes.instanceOf(Function).isRequired,
  getBarangayList: PropTypes.instanceOf(Function).isRequired,
  provinceList: PropTypes.instanceOf(Array).isRequired,
  districtList: PropTypes.instanceOf(Array).isRequired,
  barangayList: PropTypes.instanceOf(Array).isRequired,
  type: PropTypes.string,
  getLandApplicationsList: PropTypes.instanceOf(Function).isRequired,
  htmlToDraft: PropTypes.instanceOf(Function).isRequired,
  draftToHtml: PropTypes.instanceOf(Function).isRequired,
  convertToRaw: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  getTdn: PropTypes.instanceOf(Function).isRequired,
  getPin: PropTypes.instanceOf(Function).isRequired,
  getLocationList: PropTypes.instanceOf(Function).isRequired,
  locationList: PropTypes.instanceOf(Array).isRequired,
  getPersonOfConcernList: PropTypes.instanceOf(Function).isRequired,
  personOfConcernList: PropTypes.instanceOf(Array).isRequired,
  getEffectivityDateTransfer: PropTypes.instanceOf(Function).isRequired,
  effectivityDate: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  transactionList: _.get(api, `${c.GET_TRANSACTION_CODES}.list`) || [],
  ownerList: _.get(api, `${c.GET_LAND_OWNER}.list`) || [],
  provinceList: _.get(api, `${c.GET_PROVINCE}.list`) || [],
  districtList: _.get(api, `${c.GET_DISTRICTS}.list`) || [],
  barangayList: _.get(api, `${c.GET_BARANGAYS}.list`) || [],
  locationList: _.get(api, `${c.GET_LOCATION_LIST}.list`) || [],
  personOfConcernList: _.get(api, `${c.GET_PERSON_OF_CONCERN}.list`) || [],
  effectivityDate: _.get(api, `${c.GET_EFFECTIVITY_TRANSFER}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(LandApplicationModal);
